import { Injectable, ElementRef, Renderer } from '@angular/core';

import { ApiService, AppContext, CacheService, LogService, FavoriteService, SeoService, Schedule, Carrier } from './../shared';
import { Port } from './../shared/models';

@Injectable()
export class PortsService {
  queryString: string = '';

  public loaderOff = false;
  public noResult = false;
  el: HTMLElement;
  content: HTMLElement;
  container: HTMLElement;

  constructor(private api: ApiService, private cache: CacheService, private logger: LogService, private favorite: FavoriteService, private seo: SeoService, public app: AppContext, el: ElementRef, private renderer: Renderer) {
  }

  getPortSchedules(portId: number, params: any): Promise<any> {
    this.logger.log('ports.service', 'getPortSchedules', portId);
    this.noResult = false;
    // let cache = this.cache.get('ports' + this.queryString);
    let promise = this.api.getApiClient().then(client => this.callGetPortSchedules(client, portId, params));
    // let server = Observable.fromPromise(promise);

    // this.schedules = Observable.concat(cache, server);
    // this.schedules = server;
    // this.cache.updateCache('ports' + this.queryString, this.schedules);

    return promise;
  }

  callGetPortSchedules(apigClient: any, portId: number, query: any): Promise<any> {
    this.logger.log('ports.service', 'callGetPortSchedules', portId);
    return new Promise((resolve, reject) => {
      let params = {
        portId: portId
      };
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: query
      };
      try {
        apigClient.portsPortIdSchedulesGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('ports.service', 'result', result);
            if (result.data === null) {
              this.resizeSidebar();
              this.loaderOff = true;
              this.noResult = true;
            } else if (result.data.items.length === 0 || result.data.summary.count === 0) {
              this.resizeSidebar();
              this.loaderOff = true;
              this.noResult = true;
            } else {
              this.resizeSidebar();
              this.loaderOff = true;
            }

            let formatted = {
              searchId: result.data.searchId,
              total: result.data.summary.count,
              carriers: Array<any>(),
              selectedCarriers: result.data.summary.selected_carriers,
              excludedCarriers: result.data.summary.excluded_carriers,
              items: Array<Schedule>()
            };

            for (let current = 0; current < result.data.items.length; current++) {
              formatted.items[current] = new Schedule(result.data.items[current]);
            }

            let selected = result.data.summary.selected_carriers;
            let available = result.data.summary.available_carriers;
            let excluded = result.data.summary.excluded_carriers;

            for (let current = 0; current < available.length; current++) {
              formatted.carriers[current] = available[current];
              formatted.carriers[current].carrier = new Carrier(formatted.carriers[current].carrier);
              formatted.carriers[current].selected = this.isCarrierSelected(available[current].carrier.id, selected, excluded);

              formatted.carriers[current].iconUrl = '../img/carriers/' + formatted.carriers[current].carrier.id + '.gif';
            }

            this.logger.log('ports.service', 'formatted', formatted);
            resolve(formatted);
          }).catch((err) => {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        reject(null);
      }
    });
  }

  isCarrierSelected(carrierId: Number, selected: Array<Number>, excluded: Array<Number>): boolean {
    if (selected.length === 0 && excluded.length === 0) {
      return true;
    }

    // excluded
    if (excluded.indexOf(carrierId) > -1) {
      return false;
    }

    // selected and not excluded
    if (selected.indexOf(carrierId) > -1) {
      return true;
    }

    // not selected
    if (selected.length !== 0) {
      return false;
    }

    // not excluded
    return true;
  }

  formatResult(result) {
    let formatted;
    formatted.items = Array<Schedule>();
    for (let current = 0; current < result.data.items.length; current++) {
      formatted.items[current] = new Schedule(result.data.items[current]);
    }
    return formatted.items;
  }

  getPort(portId: number): Promise<any> {
    this.logger.log('ports.service', 'getPort', portId);
    // let cache = this.cache.get('ports' + portId);
    let promise = this.api.getApiClient().then(client => this.callGetPort(client, portId));
    // let server = Observable.fromPromise(promise);
    // this.port = server;
    // this.port = Observable.concat(cache, server);
    // this.port = this.cache.updateCache('ports' + this.queryString, this.port);
    return promise;
  }

  callGetPort(apigClient: any, portId: number): Promise<any> {
    this.logger.log('ports.service', 'callGetPort', portId);
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          id: portId
        }
      };
      try {
        apigClient.portsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('ports.service', 'port result', result);
            let port = new Port(result.data.items[0]);
            this.seo.setPort(port);

            resolve(port);
          }).catch((err) => reject(this.api.handleError(err)));
      } catch (ex) {
        reject(null);
      }
    });
  }

  resizeSidebar() {
    setTimeout(() => {
      try {
        this.el = document.getElementById('refine-sidebar-inner');
        this.content = document.getElementById('results-content');
        this.container = document.getElementById('content-sidebar-wrapper');

        this.renderer.setElementProperty(this.container, 'style', false);

        if (this.el.scrollHeight > this.content.scrollHeight) {
          let heightNum = (this.el.scrollHeight + 200);
          this.renderer.setElementStyle(this.container, 'height', heightNum + 'px');
        }
      } catch (ex) {
      }
    }, 10);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/ports/ports.service.ts